/**
 * Basic dialog implementation.
 */

import { className } from "utils/strings";

import BACK_ICON from "../icons/left_arrow.svg";
import CLOSE_ICON from "../icons/close.svg";

import "./Dialog.scss";

export const Dialog = (props: {
  onBack?: () => void;
  onClose?: () => void;
  title: string;
  children: JSX.Element;
  buttons?: JSX.Element;
  className?: string;
}): JSX.Element => {
  const onBack = () => {
    props.onBack && props.onBack();
  };

  const onClose = () => {
    props.onClose && props.onClose();
  };

  return (
    <div className={className({
      "dialog": true,
      [props.className ?? ""]: true,
    })}>
      <div className="backdrop"></div>
      <div className="canvas">
        <div className="dialogHeader">
          {props.onBack && (
            <button className="back button" onClick={onBack}>
              <img src={BACK_ICON} alt="" />
            </button>
          )}
          <div className="dialogTitle">{props.title}</div>
          {props.onClose && (
            <button className="close button" onClick={onClose}>
              <img src={CLOSE_ICON} alt="" />
            </button>
          )}
        </div>

        <div className="dialogContent">
          {props.children}
        </div>

        {props.buttons && (
          <div className="dialogButtons">
            {props.buttons}
          </div>
        )}
      </div>
    </div>
  );
};
